import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  ThemeProvider,
  ToastProvider,
  ServiceProvider,
  AuthProvider,
  ConfirmationProvider,
  useServices,
} from '@/app/providers';
import { AuthGuard } from '@/modules/auth/ui/components';
import AppLayout from '@/layout/AppLayout';
import { DashboardPage } from '@/pages/DashboardPage';
import { TenantListPage, TenantDetailPage, TenantOnboardingPage } from '@/modules/tenants/ui/pages';
import { ApiKeyListPage } from '@/modules/apikeys/ui/pages';
import { BillingPage } from '@/modules/billing/ui/pages';
import { AdminsPage } from '@/modules/admins/ui/pages';
import { AuditPage } from '@/modules/audit/ui/pages';
import { IntegrationsPage } from '@/modules/integrations/ui/pages';
import { EmailTemplateListPage, EmailTemplateDetailPage } from '@/modules/email-templates';
import { NotificationsPage } from '@/modules/notifications';

function AuthenticatedApp() {
  return (
    <AuthGuard>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/tenants" element={<TenantListPage />} />
          <Route path="/tenants/new" element={<TenantOnboardingPage />} />
          <Route path="/tenants/:id" element={<TenantDetailPage />} />
          <Route path="/api-keys" element={<ApiKeyListPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/admins" element={<AdminsPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/email-templates" element={<EmailTemplateListPage />} />
          <Route path="/email-templates/:id" element={<EmailTemplateDetailPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
        </Route>
      </Routes>
    </AuthGuard>
  );
}

function AppWithAuth() {
  const { authRepository } = useServices();

  return (
    <AuthProvider authRepository={authRepository}>
      <ConfirmationProvider>
        <AuthenticatedApp />
      </ConfirmationProvider>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ToastProvider>
          <ServiceProvider>
            <AppWithAuth />
          </ServiceProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
